module.exports = __webpack_public_path__ + "img/icon-sunny.0a77f7e3.png";